import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPrinter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPrinter"><Path fillRule="evenodd" clipRule="evenodd" d="M18 2H6V6H2V18H6V22H18V18H22V6H18V2ZM16.5 6V3.5H7.5V6H16.5ZM16.5 14.5H7.5V20.5H16.5V14.5ZM6 10H10V11.5H6V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPrinter;
